<template>
  <v-container class="py-6">
    <!-- Encabezado principal rojo con texto blanco -->
    <div class="header-formulario mb-6">
      <h1 class="titulo-formulario">{{ formulario.NombreFormulario }}</h1>
    </div>

    <v-expansion-panels v-model="activePanels" multiple>
      <v-expansion-panel
        class="mb-5"
        v-for="(section, index) in formulario.Seccion"
        :key="index"
      >
        <v-expansion-panel-title class="barra-seccion px-4 py-2">
          {{ section.Nombre }}
        </v-expansion-panel-title>
        <!--Seccion Estadar-->
        <v-expansion-panel-text v-if="section.TipoSeccion == 1">
          <!-- Aquí va contenido dinámico o campos por sección -->
          <v-row>
            <v-col
              v-for="(campo, j) in section.Campos"
              :key="j"
              cols="12"
              sm="6"
              :md="
                campo.TipoCampo == '9' ||
                campo.TipoCampo == '7' ||
                campo.TipoCampo == '13' ||
                campo.TipoCampo == '14'
                  ? '12'
                  : '4'
              "
            >
              <!-- Render dinámico de campos -->
              <v-text-field
                v-if="campo.TipoCampo == '1'"
                v-model="campo.Valor"
                :label="campo.Requerido ? campo.Label + ' (*)' : campo.Label"
                :hint="campo.Requerido ? 'Campo Obligatorio (*)' : ''"
                :rules="[rules.obligatorio(campo.Requerido, campo.Valor)]"
                :error="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                "
                :error-messages="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                    ? 'Este campo es obligatorio.'
                    : ''
                "
                :readonly="
                  formdata && formdata.EstadoFormulario == 3 ? true : false
                "
                :clearable="
                  formdata && formdata.EstadoFormulario == 3 ? false : true
                "
                :ref="'campo_' + campo.CampoId"
                enterkeyhint="done"
                @keydown.enter="PostReporteFormulario(campo)"
                @keyup.enter="PostReporteFormulario(campo)"
                outlined
                dense
              />
              <!-- Texto Numerico -->
              <v-text-field
                v-else-if="campo.TipoCampo == '2'"
                v-model="campo.Valor"
                :label="campo.Requerido ? campo.Label + ' (*)' : campo.Label"
                :hint="campo.Requerido ? 'Campo Obligatorio (*)' : ''"
                type="tel"
                v-on:keypress="isNumber()"
                outlined
                :rules="[rules.obligatorio(campo.Requerido, campo.Valor)]"
                :error="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                "
                :error-messages="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                    ? 'Este campo es obligatorio.'
                    : ''
                "
                :ref="'campo_' + campo.CampoId"
                :readonly="
                  formdata && formdata.EstadoFormulario == 3 ? true : false
                "
                :clearable="
                  formdata && formdata.EstadoFormulario == 3 ? false : true
                "
                dense
              ></v-text-field>
              <!-- Fechas-->
              <v-text-field
                v-else-if="campo.TipoCampo == '3'"
                v-model="campo.Valor"
                type="date"
                :rules="[rules.obligatorio(campo.Requerido, campo.Valor)]"
                :hint="campo.Requerido ? 'Campo Obligatorio (*)' : ''"
                :error="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                "
                :error-messages="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                    ? 'Este campo es obligatorio.'
                    : ''
                "
                :label="campo.Requerido ? campo.Label + ' (*)' : campo.Label"
                :ref="'campo_' + campo.CampoId"
                onkeydown="return false"
                :readonly="
                  formdata && formdata.EstadoFormulario == 3 ? true : false
                "
                :clearable="
                  formdata && formdata.EstadoFormulario == 3 ? false : true
                "
              ></v-text-field>
              <!-- Checkbox -->
              <v-checkbox
                v-else-if="campo.TipoCampo == '4'"
                color="success"
                v-model="campo.Valor"
                :rules="[rules.obligatorio(campo.Requerido, campo.Valor)]"
                :hint="campo.Requerido ? 'Campo Obligatorio (*)' : ''"
                :error="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                "
                :error-messages="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                    ? 'Este campo es obligatorio.'
                    : ''
                "
                :label="campo.Requerido ? campo.Label + ' (*)' : campo.Label"
                :ref="'campo_' + campo.CampoId"
                value="campo.Label"
                :readonly="
                  formdata && formdata.EstadoFormulario == 3 ? true : false
                "
                :clearable="
                  formdata && formdata.EstadoFormulario == 3 ? false : true
                "
                hide-details
              ></v-checkbox>
              <!--Lista-->
              <v-autocomplete
                v-else-if="campo.TipoCampo == '5'"
                v-model="campo.Valor"
                :items="campo.tablaSeleccions"
                :item-title="(data) => data.Valor + '-' + data.Descripcion"
                item-value="Valor"
                color="primary"
                :hint="campo.Requerido ? 'Campo Obligatorio (*)' : ''"
                :rules="[rules.obligatorio(campo.Requerido, campo.Valor)]"
                :error="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                "
                :error-messages="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                    ? 'Este campo es obligatorio.'
                    : ''
                "
                :ref="'campo_' + campo.CampoId"
                :label="campo.Requerido ? campo.Label + ' (*)' : campo.Label"
                :readonly="
                  formdata && formdata.EstadoFormulario == 3 ? true : false
                "
                :clearable="
                  formdata && formdata.EstadoFormulario == 3 ? false : true
                "
              >
              </v-autocomplete>
              <!-- Firma -->
              <card-firma
                v-else-if="campo.TipoCampo == '6'"
                v-model="campo.Base64"
                :formData="formdata"
              />

              <!-- textos grandes -->
              <v-textarea
                v-else-if="campo.TipoCampo == '7'"
                v-model="campo.Valor"
                no-resize
                :rules="[rules.obligatorio(campo.Requerido, campo.Valor)]"
                :hint="campo.Requerido ? 'Campo Obligatorio (*)' : ''"
                :error="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                "
                :error-messages="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                    ? 'Este campo es obligatorio.'
                    : ''
                "
                :ref="'campo_' + campo.CampoId"
                rows="8"
                :label="campo.Requerido ? campo.Label + ' (*)' : campo.Label"
                :readonly="
                  formdata && formdata.EstadoFormulario == 3 ? true : false
                "
                :clearable="
                  formdata && formdata.EstadoFormulario == 3 ? false : true
                "
              >
              </v-textarea>
              <!-- Fechas y Hora-->
              <v-text-field
                v-else-if="campo.TipoCampo == '8'"
                type="datetime-local"
                v-model="campo.Valor"
                :hint="campo.Requerido ? 'Campo Obligatorio (*)' : ''"
                :label="campo.Requerido ? campo.Label + ' (*)' : campo.Label"
                :rules="[rules.obligatorio(campo.Requerido, campo.Valor)]"
                :ref="'campo_' + campo.CampoId"
                :error="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                "
                :error-messages="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                    ? 'Este campo es obligatorio.'
                    : ''
                "
                onkeydown="return false"
                :readonly="
                  formdata && formdata.EstadoFormulario == 3 ? true : false
                "
                :clearable="
                  formdata && formdata.EstadoFormulario == 3 ? false : true
                "
              ></v-text-field>
              <!-- Titulos -->
              <span v-else-if="campo.TipoCampo == '9'" class="etiqueta-rol">
                {{ campo.Label }}
              </span>
              <!--Departamento-->
              <v-autocomplete
                v-else-if="campo.TipoCampo == '10'"
                v-model="campo.Valor"
                :items="ArrayDpto_ID"
                :item-title="
                  (ArrayDpto_ID) =>
                    ArrayDpto_ID.DepartamentoId + '-' + ArrayDpto_ID.Nombre
                "
                item-value="DepartamentoId"
                color="primary"
                :hint="campo.Requerido ? 'Campo Obligatorio (*)' : ''"
                :rules="[rules.obligatorio(campo.Requerido, campo.Valor)]"
                :error="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                "
                :error-messages="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                    ? 'Este campo es obligatorio.'
                    : ''
                "
                :ref="'campo_' + campo.CampoId"
                :label="campo.Requerido ? campo.Label + ' (*)' : campo.Label"
                :update:modelValue="getCity_ID(campo.Valor, campo.TipoCampo)"
                :readonly="
                  formdata && formdata.EstadoFormulario == 3 ? true : false
                "
                :clearable="
                  formdata && formdata.EstadoFormulario == 3 ? false : true
                "
              >
              </v-autocomplete>
              <!--Ciudad -->
              <v-autocomplete
                v-else-if="campo.TipoCampo == '11'"
                v-model="campo.Valor"
                :items="ArrayCiudad_ID"
                :item-title="
                  (ArrayCiudad_ID) =>
                    ArrayCiudad_ID.CiudadId + '-' + ArrayCiudad_ID.Nombre
                "
                :hint="campo.Requerido ? 'Campo Obligatorio (*)' : ''"
                :rules="[rules.obligatorio(campo.Requerido, campo.Valor)]"
                :error="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                "
                :error-messages="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                    ? 'Este campo es obligatorio.'
                    : ''
                "
                :ref="'campo_' + campo.CampoId"
                item-value="CiudadId"
                color="primary"
                :label="campo.Requerido ? campo.Label + ' (*)' : campo.Label"
                :readonly="
                  formdata && formdata.EstadoFormulario == 3 ? true : false
                "
                :clearable="
                  formdata && formdata.EstadoFormulario == 3 ? false : true
                "
              >
              </v-autocomplete>
              <!-- Hora -->
              <v-text-field
                v-else-if="campo.TipoCampo == '12'"
                v-model="campo.Valor"
                type="time"
                :label="campo.Requerido ? campo.Label + ' (*)' : campo.Label"
                :rules="[rules.obligatorio(campo.Requerido, campo.Valor)]"
                :error="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                "
                :hint="campo.Requerido ? 'Campo Obligatorio (*)' : ''"
                :error-messages="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                    ? 'Este campo es obligatorio.'
                    : ''
                "
                :ref="'campo_' + campo.CampoId"
                :readonly="
                  formdata && formdata.EstadoFormulario == 3 ? true : false
                "
                :clearable="
                  formdata && formdata.EstadoFormulario == 3 ? false : true
                "
              ></v-text-field>
              <!--Combo Lista Multiple-->
              <v-autocomplete
                v-else-if="campo.TipoCampo == '13'"
                :model-value="campo.Valor ? campo.Valor.split(',') : []"
                :items="campo.tablaSeleccions"
                color="blue-grey-lighten-2"
                item-title="Descripcion"
                item-value="Valor"
                :hint="campo.Requerido ? 'Campo Obligatorio (*)' : ''"
                :label="campo.Requerido ? campo.Label + ' (*)' : campo.Label"
                type="text"
                :rules="[rules.obligatorio(campo.Requerido, campo.Valor)]"
                :error="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                "
                :error-messages="
                  campo.MostrarError && (!campo.Valor || campo.Valor === '')
                    ? 'Este campo es obligatorio.'
                    : ''
                "
                :ref="'campo_' + campo.CampoId"
                :readonly="
                  formdata && formdata.EstadoFormulario == 3 ? true : false
                "
                :clearable="
                  formdata && formdata.EstadoFormulario == 3 ? false : true
                "
                multiple
                @update:modelValue="(val) => (campo.Valor = val.join(','))"
              ></v-autocomplete>
              <!--Span-->
              <span v-else-if="campo.TipoCampo == '14'">
                {{ campo.Label }}
              </span>
              <!-- Documentos (Archivos) -->
              <v-file-input
                v-else-if="campo.TipoCampo == '15'"
                multiple
                show-size
                counter
                accept=".pdf,.jpg,.png,.doc,.docx,.xls,.xlsx, .zip"
                :label="campo.Requerido ? campo.Label + ' (*)' : campo.Label"
                :hint="campo.Requerido ? 'Campo Obligatorio (*)' : ''"
                :rules="[rules.obligatorio(campo.Requerido, campo.archivos)]"
                :error="
                  campo.MostrarError &&
                  (!campo.archivos || campo.archivos.length === 0)
                "
                :error-messages="
                  campo.MostrarError &&
                  (!campo.archivos || campo.archivos.length === 0)
                    ? 'Este campo es obligatorio.'
                    : ''
                "
                :ref="'campo_' + campo.CampoId"
                :readonly="
                  formdata && formdata.EstadoFormulario == 3 ? true : false
                "
                :clearable="
                  formdata && formdata.EstadoFormulario == 3 ? false : true
                "
                outlined
                dense
                @change="handleFiles($event, campo)"
              >
                <template v-slot:append-inner>
                  <v-icon
                    class="mr-2 cursor-pointer"
                    :color="
                      campo.Archivos && campo.Archivos.length > 0
                        ? 'success'
                        : 'warning'
                    "
                    @click.stop="
                      openPreview(
                        formulario.FormularioId,
                        historicoId,
                        section.SeccionId,
                        campo.CampoId,
                        campo.ValorId
                      )
                    "
                  >
                    {{
                      campo.Archivos && campo.Archivos.length > 0
                        ? "mdi-eye"
                        : "mdi-eye-off"
                    }}
                  </v-icon>
                </template>
              </v-file-input>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
        <!--Seccion Tabla-->
        <v-expansion-panel-text v-else-if="section.TipoSeccion == 2">
          <div style="overflow-x: auto; width: 100%">
            <v-table class="custom-table">
              <thead>
                <tr>
                  <th
                    v-for="col in section.Tablas.Columnas"
                    :key="col.IdColumna"
                    class="font-weight-bold"
                  >
                    {{ col.NombreColumna }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(fila, index) in section.Tablas.Filas"
                  :key="fila.CampoId"
                >
                  <td
                    class="text-left"
                    v-for="(celda, celdaindex) in fila.Celdas"
                    :key="celda.IdColumna"
                  >
                    <span
                      v-if="celdaindex == 0 && section.Tablas.TipoTabla == 1"
                      >{{ fila.NombreCampo }}</span
                    >
                    <v-text-field
                      v-else-if="
                        (celdaindex > 0 && section.Tablas.TipoTabla == 1) ||
                        section.Tablas.TipoTabla == 2
                      "
                      v-model="celda.Valor"
                      :label="celda.Label"
                      :rules="[rules.obligatorio(celda.Requerido, celda.Valor)]"
                      :type="getTipoInput(celda.TipoColumna)"
                      dense
                      hide-details="auto"
                    />
                  </td>
                </tr>
              </tbody>
            </v-table>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <!--Mostramos Boton siempre y cuando sea diferente a esta completado -->
    <v-btn
      v-if="!formdata || (formdata && formdata.EstadoFormulario != null)"
      color="success"
      @click="guardarFormulario"
      >Guardar</v-btn
    >
  </v-container>

  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

  <!-- Vista preliminar en un diálogo -->
  <v-dialog v-model="dialog" max-width="800px" persistent>
    <v-card>
      <v-card-title class="text-h6">Vista preliminar</v-card-title>
      <v-card-text>
        <div v-for="(file, index) in files" :key="index" class="mb-4">
          <p>
            <strong
              >{{ file.NombreArchivo }}
              <!-- Botón de descarga -->
              <v-btn
                color="red-darken-4"
                class="ma-2 white--text"
                small
                @click="getDownloadLink(file)"
              >
                Descargar Archivo<v-icon right dark> mdi-download </v-icon>
              </v-btn>
              <!-- Botón de eliminación -->
              <v-icon
                v-if="formdata && formdata.EstadoFormulario != 3"
                class="mr-2 cursor-pointer"
                color="red-darken-4"
                @click.stop="Desactivar(file.IdValor)"
              >
                mdi-delete
              </v-icon>
            </strong>
          </p>
          <div v-if="isImage(file)">
            <img
              :src="file.ArchivoBase64"
              alt="preview"
              style="max-width: 100%; max-height: 300px"
            />
          </div>
          <div v-else-if="file.ArchivoBase64.includes('pdf')">
            <embed
              :src="file.ArchivoBase64"
              type="application/pdf"
              width="100%"
              height="400px"
            />
          </div>
          <div v-else>
            <v-icon color="grey">mdi-file</v-icon>
            <span>Archivo no soportado para vista previa</span>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FirmaDialog from "@/views/components/Generales/Firma/CampoFirma.vue";
import { readonly } from "vue";

export default {
  name: "Formulario-Dinamico",
  components: {
    "card-firma": FirmaDialog,
  },
  props: {
    historicoId: {
      type: Number,
      default: 0,
      Description: "Información de Histórico",
    },
    formularioId: {
      type: Number,
      default: 0,
      Description: "Información de Formularios",
    },
    formdata: {
      type: Object,
      default: null,
      Description: "Información de Formulario Diligenciado",
    },
    pageiframe: {
      type: Boolean,
      default: true,
      Description: "Información de Formulario Dialogo",
    },
  },
  data() {
    return {
      progreso: false,
      dialog: false,
      files: [],
      formulario: [],
      activePanels: [],
      filasUnicas: [],
      ArrayCiudad_ID: [],
      ArrayDpto_ID: [],
      rules: {
        obligatorio(isRequired, v) {
          if (isRequired && (!v || v === "")) {
            return "Este campo es obligatorio.";
          } else {
            return true;
          }
        },
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Email Inválido.";
        },
      },
      formId: 0,
      seccionId: 0,
      valorId: 0,
      campoId: 0,
      historico: 0,
    };
  },
  methods: {
    // Es número
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    // Get Tipo Input
    getTipoInput(tipoColumna) {
      switch (tipoColumna) {
        case 1:
          return "text";
        case 2:
          return "number";
        case 3:
          return "date";
        default:
          return "text";
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////

    // Envia Consulta de Formularios Dinamicos
    async GetFormularios() {
      this.progreso = true;
      this.formulario = [];
      var page = this.$store.getters.userperfil.paginainfo;
      var FormId = this.formularioId > 0 ? this.formularioId : page.param1;
      this.axios
        .get(
          "/Formularios/Formulario/GetFormularios?idForm=" +
            FormId +
            "&idHistorico=" +
            this.historicoId
        )
        .then((response) => {
          if (response.data.Status == 200) {
            this.formulario = response.data;
          } else {
            this.$swal({
              icon: "warning",
              title: "Consulta inexistente.",
              html: response.data.Message,
            });
          }
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    // Validar que los campos obligatorios sean diligenciados
    async validarCamposRequeridos() {
      let esValido = true;

      this.formulario.Seccion.forEach((seccion) => {
        // Validar campos estándar
        if (seccion.TipoSeccion === 1) {
          seccion.Campos.forEach((campo) => {
            if (
              campo.Requerido &&
              campo.TipoCampo != "6" &&
              (!campo.Valor || campo.Valor.toString().trim() === "")
            ) {
              esValido = false;
              // Forzar error para que se muestre en el campo
              campo.MostrarError = true;
            } else if (
              campo.Requerido &&
              campo.TipoCampo == "6" &&
              (!campo.Base64 || campo.Base64.toString().trim() === "")
            ) {
              esValido = false;
              // Forzar error para que se muestre en el campo
              campo.MostrarError = true;
            } else {
              campo.MostrarError = false;
            }
          });
        }

        // Validar campos de tabla
        if (seccion.TipoSeccion === 2 && seccion.Tablas) {
          seccion.Tablas.Filas.forEach((fila) => {
            fila.Celdas.forEach((celda) => {
              if (
                celda.Requerido &&
                (!celda.Valor || celda.Valor.toString().trim() === "")
              ) {
                esValido = false;
                celda.MostrarError = true;
              } else {
                celda.MostrarError = false;
              }
            });
          });
        }
      });

      return esValido;
    },

    // Validacion de campo formulario
    async guardarFormulario() {
      const esValido = await this.validarCamposRequeridos();
      if (esValido) {
        // Aquí puedes continuar con el envío del formulario
        this.PostFormulariosDiligenciado();
      } else {
        this.$swal({
          icon: "question",
          title: "Guardar Formulario",
          html: "Existen campos obligatorios que no se encuentran diligenciados, ¿Desea guardar igualmente el formulario?<br>Esta acción no se puede deshacer luego de confirmarla.",
          confirmButtonText: "Sí",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.PostFormulariosDiligenciado();
          }
        });
      }
    },

    // Envia Consulta de Formularios
    async PostFormulariosDiligenciado() {
      this.progreso = true;
      var userperfil = this.$store.getters.userperfil;
      this.formulario.UsuarioId = userperfil.userInfo.Usuario_ID;
      this.axios
        .post("/Formularios/FormularioDiligenciado/CR0", this.formulario)
        .then((response) => {
          if (response.data.Status == 200) {
            this.$swal({
              icon: "success",
              title: "¡Éxito!",
              html: response.data.Message,
            });
            var data = false;
            this.$emit("update:pageiframe", data);
          } else {
            this.$swal({
              icon: "warning",
              title: "Consulta inexistente.",
              html: response.data.Message,
            });
          }
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    // Envia Consulta de Reporte Formulario
    async PostReporteFormulario(campo) {
      if (campo.Llave && campo.Valor) {
        this.progreso = true;
        var userperfil = this.$store.getters.userperfil;
        this.formulario.UsuarioId = userperfil.userInfo.Usuario_ID;
        this.axios
          .post(
            "/Formularios/FormularioDiligenciado/ReporteFormulario",
            this.formulario
          )
          .then((response) => {
            if (response.data.Status == 200) {
              this.formulario = response.data.Data;
            } else {
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: response.data.Message,
              });
            }
          })
          .catch((error) => {
            console.log(error);
            const registro = error.response.data;
            const mensajeerror =
              registro.Mensaje || registro.ExceptionMessage || registro;
            switch (error.response.status) {
              case 404:
                this.$swal({
                  icon: "warning",
                  title: "Consulta inexistente.",
                  html: mensajeerror,
                });
                break;
              default:
                this.$swal({
                  icon: "error",
                  title: "Error al consultar",
                  html:
                    " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                    mensajeerror +
                    "</code></small>",
                });
                break;
            }
          })
          .finally(() => {
            this.progreso = false;
          });
      }
    },

    // Configurar Desactivación
    Desactivar(idvalor) {
      this.$swal({
        icon: "question",
        title: "Eliminar Información",
        html: "¿Está seguro que desea eliminar la información seleccionada?<br>Esta acción no se puede deshacer luego de confirmarla.",
        confirmButtonText: "Sí",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.isConfirmed) {
          this.UpdateCampoDesactivado(idvalor);
        }
      });
    },

    // Envia Consulta de Campo descactivado
    async UpdateCampoDesactivado(idvalor) {
      this.progreso = true;
      var userperfil = this.$store.getters.userperfil;

      this.axios
        .get(
          "/Formularios/FormularioDiligenciado/DesactivacionCampo/" +
            idvalor +
            "/" +
            userperfil.userInfo.Usuario_ID,
          this.formulario
        )
        .then((response) => {
          if (response.data.Status == 200) {
            this.$swal({
              icon: "success",
              title: "¡Éxito!",
              html: response.data.Message,
            });
            this.openPreview(
              this.formId,
              this.historico,
              this.seccionId,
              this.campoId,
              this.valorId
            );
          } else {
            this.$swal({
              icon: "warning",
              title: "Consulta inexistente.",
              html: response.data.Message,
            });
          }
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    // Get para obtener array de los departamento existentes
    getDpto_ID() {
      var ArrayDpto_ID2 = this.$store.getters.MDpto;
      this.ArrayDpto_ID = ArrayDpto_ID2.filter(
        (item) => item.DepartamentoId != 0
      ).map((item) => ({
        ...item,
        DepartamentoId: String(item.DepartamentoId), // <-- Aquí se convierte a string
      }));
    },

    // Método de gestion cambio
    getCity_ID(Dpto, TipoCampo) {
      if (TipoCampo == "10") {
        var ArrayCiudad_ID2 = this.$store.getters.MCity;
        this.ArrayCiudad_ID = ArrayCiudad_ID2.filter(
          (item) => item.CiudadId != 0 && item.DepartamentoId == Dpto
        ).map((item) => ({
          ...item,
          CiudadId: String(item.CiudadId),
          DepartamentoId: String(item.DepartamentoId),
        }));
      }
    },

    // Método que convierte archivos en Base 64
    handleFiles(event, campo) {
      const selectedFiles = event.target.files;
      console.log(campo);
      campo.Archivos = []; // lo guardamos aquí como arreglo de base64

      Array.from(selectedFiles).forEach((file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          campo.Archivos.push({
            NombreArchivo: file.name,
            Extension: file.type,
            ArchivoBase64: e.target.result,
          });
        };
        reader.readAsDataURL(file);
      });
    },

    // Método que muestra archivos en Base 64
    openPreview(formId, historicoId, idSeccion, idCampo, valorId) {
      this.formId = formId;
      this.seccionId = idSeccion;
      this.valorId = valorId;
      this.campoId = idCampo;
      this.historico = historicoId;
      this.files = [];
      this.progreso = true;
      this.axios
        .get(
          "/Formularios/Formulario/GetFormulariosArchivo?idForm=" +
            formId +
            "&idHistorico=" +
            historicoId +
            "&idSeccion=" +
            idSeccion +
            "&idCampo=" +
            idCampo
        )
        .then((response) => {
          if (response.data.Status == 200) {
            this.files = response.data.Data;
            this.dialog = true;
          } else {
            this.$swal({
              icon: "warning",
              title: "Consulta inexistente.",
              html: response.data.Message,
            });
          }
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    // Método que valida si es una imagente
    isImage(file) {
      return file.ArchivoBase64 && file.ArchivoBase64.includes("image/");
    },

    // Método para descargar el Documento consultado
    getDownloadLink(file) {
      let archivoName = `${file.NombreArchivo}`;
      // Crear un enlace de descarga para descargar el archivo
      const link = document.createElement("a");
      link.href = `${file.ArchivoBase64}`;
      link.download = archivoName; // El nombre del archivo con la extensión
      link.click(); // Dispara la descarga
    },
  },
  mounted() {
    this.GetFormularios();
    this.getDpto_ID();
  },
};
</script>

<style scoped>
/* Título general */
.header-formulario {
  background-color: #c62828; /* rojo fuerte */
  color: white;
  padding: 16px;
  border-radius: 8px;
  text-align: center;
}

.etiqueta-rol {
  display: inline-block;
  background-color: #5c5c5c;
  color: white;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 12px;
  margin-bottom: 2px;
  margin-top: 0px;
  font-size: 14px;
}

.titulo-formulario {
  font-size: 26px;
  margin: 0;
  font-weight: bold;
}

/* Barra de cada sección */
.barra-seccion {
  background-color: #c62828;
  color: white;
  font-weight: bold;
  font-size: 14px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.custom-table {
  width: 100%;
  table-layout: auto; /* deja que las celdas se ajusten */
  border-collapse: collapse;
}

.custom-table th,
.custom-table td {
  padding: 6px;
  min-width: 120px; /* asegura legibilidad en responsive */
  vertical-align: middle;
}
</style>
